import { CircularProgress } from "@bb-ui/react-library/dist/components/Progress";
import * as React from "react";
import { useTranslation } from "react-i18next";

export const LoadingState: React.FC<Record<string, never>> = () => {
  const { t } = useTranslation();

  return (
    <div className="full-screen-wrapper" aria-live="polite" role="status">
      <CircularProgress
        id="doc-viewer-loading"
        label={t("messages.preparing")}
        size="large"
        variant="indeterminate"
      />
    </div>
  );
};
